import { inr } from "@/lib/format";

/** Editorial shell per slide — product name/price/image come from the catalog. */
export const HERO_SLIDE_CONFIG = [
  {
    productId: "dresses-004-cream",
    fallbackImage: "/api/static/products/dresses/1001586781.jpg",
    eyebrow: "The Resort Edit",
    title: ["Sun-soaked", "silhouettes."],
    subtitle: "Linen, silk and easy weight — for days that stretch into evenings.",
    cta: { label: "Shop Dresses", to: "/category/dresses" },
    cta2: { label: "Co-ord Sets", to: "/category/coords" },
    priceTag: "Resort · Edit",
    priceNote: "Crafted in small batches",
    accent: "#7A6A4A",
  },
  {
    productId: "dresses-009-sand",
    fallbackImage: "/api/static/products/dresses/1001586786.jpg",
    eyebrow: "Spring / Summer · 26",
    title: ["Refined by", "Simplicity."],
    subtitle: "Editorial silhouettes, considered fabrics and handmade detail — built to last beyond a season.",
    cta: { label: "Discover the edit", to: "/category/dresses" },
    cta2: { label: "Ethnic", to: "/category/ethnic" },
    priceTag: "Atelier · Soirée",
    priceNote: "Studio exclusive · made to order",
    accent: "#2A2622",
  },
  {
    productId: "ethnic-001-olive",
    fallbackImage: "/api/static/products/ethnic/1001586745.jpg",
    eyebrow: "Heritage · Craft",
    title: ["Heirloom", "reimagined."],
    subtitle: "Hand-embroidered ethnic pieces, cut for the modern Indian woman.",
    cta: { label: "Ethnic Edit", to: "/category/ethnic" },
    cta2: { label: "All collections", to: "/category/coords" },
    priceTag: "Heritage · Craft",
    priceNote: "Limited pieces · made to order",
    accent: "#9B1B3A",
  },
];

export const findHeroProduct = (pool, slide) => {
  if (!pool?.length) return null;
  if (slide.productId) {
    const byId = pool.find((p) => p.id === slide.productId);
    if (byId) return byId;
  }
  const image = slide.fallbackImage;
  return pool.find(
    (p) => p.image === image || (Array.isArray(p.images) && p.images.includes(image))
  );
};

export const resolveHeroSlides = (pool, extraProducts = {}) => {
  const merged = [...pool];
  for (const p of Object.values(extraProducts)) {
    if (p?.id && !merged.some((x) => x.id === p.id)) merged.push(p);
  }

  return HERO_SLIDE_CONFIG.map((slide) => {
    const product = findHeroProduct(merged, slide);
    const image = product?.image || product?.images?.[0] || slide.fallbackImage;
    const productName = product?.name || slide.priceTag;
    const priceValue = product?.price;
    const priceLabel = priceValue != null ? inr(priceValue) : null;

    return {
      ...slide,
      product,
      image,
      productName,
      priceLabel,
      productTo: product ? `/product/${product.id}` : slide.cta.to,
    };
  });
};
